import { render, staticRenderFns } from "./Cv.vue?vue&type=template&id=617ef128&scoped=true"
import script from "./Cv.vue?vue&type=script&lang=ts"
export * from "./Cv.vue?vue&type=script&lang=ts"
import style0 from "./Cv.vue?vue&type=style&index=0&id=617ef128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617ef128",
  null
  
)

export default component.exports